// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StatusIndicator_wrapper__16jp1","active":"StatusIndicator_active__QxwPN","reject":"StatusIndicator_reject__3xbsc"};